// extracted by mini-css-extract-plugin
module.exports = {"container":"Heading_container__2lEYh","wrapper":"Heading_wrapper__129A6","title":"Heading_title__3GewM","text":"Heading_text__dAFuu"};